import { globals } from "@/core/globals";
import { graphqlClient } from "../../../client";
import mutationDocument from "./authorizeZeroAmountPaymentMutation.graphql";
import type {
  GetCustomerPaymentInstrumentsRequestResultType,
  InputAuthorizeZeroAmountPaymentType,
  Mutations,
  MutationsAuthorizeZeroAmountPaymentArgs,
} from "@/core/api/graphql/types";

export async function authorizeZeroAmountPayment(
  customerId: string,
  payload: InputAuthorizeZeroAmountPaymentType,
): Promise<GetCustomerPaymentInstrumentsRequestResultType> {
  const { storeId, userId, currencyCode } = globals;
  const { data } = await graphqlClient.mutate<
    Required<Pick<Mutations, "authorizeZeroAmountPayment">>,
    MutationsAuthorizeZeroAmountPaymentArgs
  >({
    mutation: mutationDocument,
    variables: {
      command: {
        memberId: customerId,
        userId,
        storeId,
        currencyCode,
        ...payload,
      },
    },
  });

  return data!.authorizeZeroAmountPayment;
}
